import {useState, useEffect, useLayoutEffect} from 'react';
import { debounce } from 'lodash';

// Define breakpoints
const breakpoints = {
    mobile: 768,
    tablet: 1024,
};

const detectDeviceType = () => {
    const width = window.innerWidth;
    const isMobile = width < breakpoints.mobile;
    const isTablet = width >= breakpoints.mobile && width <= breakpoints.tablet;
    const isDesktop = width > breakpoints.tablet;
    let screenType = 'desktop';

    if (isMobile) {
        screenType = 'mobile';
    } else if (isTablet) {
        screenType = 'tablet';
    }

    return { isMobile, isTablet, isDesktop, screenType };
};

// Custom hook to detect device type
function useDeviceType() {

    const [deviceType, setDeviceType] = useState(detectDeviceType());

    useLayoutEffect(() => {
        const handleResize = debounce(() => {
            setDeviceType(detectDeviceType());
        }, 500);

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return deviceType;
}

export default useDeviceType;
